module.exports = __webpack_public_path__ + "static/media/wizard_5.3feba43d.png";